import { fetchData } from '../utils';
import { ApiResponse } from '../types';
import { TVTouchpointSetup } from '../../../../pages/calculator/MediaPlanning/components/Touchpoints/interfaces';

export const OFFLINE = 'offline';

export const getOfflineSetup = async (
  campaignScenario: string,
  category: string,
  countryISO: string,
  division: string,
  targetGroup: string | null,
  campaignTargetGroup: string
) => {
  const params = new URLSearchParams({
    campaignScenario,
    category,
    countryISO,
    division,
    campaignTargetGroup,
  });

  if (targetGroup) {
    params.append('targetGroup', targetGroup);
  }

  return fetchData<ApiResponse<TVTouchpointSetup>>(
    `/${OFFLINE}/setup?${params.toString()}`
  );
};
